import React from "react";
import { Styles } from "./styles";
// import { Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   BarElement,
//   Tooltip,
//   Legend,
//   CategoryScale,
//   LinearScale,
// } from "chart.js";

// // Register the required Chart.js components
// ChartJS.register(BarElement, Tooltip, Legend, CategoryScale, LinearScale);

import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

// Register the required Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend);

const Status = ({ statusStats }) => {
  // Map the API data to the chart data format
  const labelsMap = {
    new_request: "New request",
    active: "Active",
    pending: "Pending",
    complete: "Complete",
    in_progress: "In progress",
  };

  // Generate labels and data dynamically
  const labels = statusStats.map(
    (stat) => labelsMap[stat.status] || stat.status
  );
  const dataCount = statusStats.map((stat) => stat.total);

  const data = {
    labels: labels,
    datasets: [
      {
        label: "Status Statistics",
        data: dataCount,
        backgroundColor: [
          "#114787",
          "#A3C4DC",
          "#58A4B0",
          "#72aefa",
          "#FFB703",
        ],
        borderColor: ["#114787", "#A3C4DC", "#58A4B0", "#72aefa", "#FFB703"],
        borderWidth: 1,
      },
    ],
  };

  // Options for the Bar Chart
  const options = {
    plugins: {
      legend: {
        position: "top",
        // display: false,
      },
      tooltip: {
        enabled: true,
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    // scales: {
    //   x: {
    //     beginAtZero: true,
    //   },
    //   y: {
    //     beginAtZero: true,
    //   },
    // },
  };

  return (
    <Styles>
      <div
        style={{
          width: "300px",
          height: "300px",
          margin: "0 auto",
          marginTop: "20px",
        }}
      >
        <div className="title mb-2">{data?.datasets[0]?.label}</div>
        {/* <Bar data={data} options={options} /> */}
        <Doughnut data={data} options={options} />
      </div>
    </Styles>
  );
};

export default Status;
